import { style } from "@vanilla-extract/css";
import { vars } from "../../styles/theme.css";
import { breakpoints } from "../../styles";

// Base styles for the content box
export const surfaceContainerStyles = style({
  borderRadius: vars.radii.l,
  backgroundColor: vars.colors.surface,
  padding: vars.space.xs,
  color: vars.colors.onSurface,
  "@media": {
    [`screen and (min-width:${breakpoints[1]})`]: {
      padding: vars.space.m,
    },
  },
});
